<div [ngClass]="{ 'error': errored, 'success': (progress === 100 && !errored) }" class="progress-cont">
  <div [ngClass]="{ 'default': !getOverrideBarColor() }"
       [ngStyle]="getOverrideBarColor() !== null && { 'background-color': getOverrideBarColor() }"
       [style.width]="progress + '%'"
       class="progress">
  </div>
</div>
